import React,{Component} from 'react';
import { apisettigs } from '../../../src/settings.js';
import './Solicitacao.css';
import { ModalConfirm, ModalConfirmReject, ModalWtng, ModalHasUnreadMsg } from './modals.js';
import { Modal } from 'bootstrap';


class Solicitacao extends Component{
  
    constructor(props) {        
        super(props);
        this.state = {
            show: false,
            selectedId: '',  
            isBkp:'',
            oriApprv:'',          
            requests: [],
        };

    }

    showSolic = () => {

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json charset=utf-8', },
            body: JSON.stringify({ userid: window.sessionStorage.getItem("userId") })
        };

        fetch(apisettigs.endpoints.requests, requestOptions).then(response => response.json())
        .then(data => {
            this.setState({requests: data});
            //console.log(data);
            this.setState({show: true});
        });
        
    }
    
    hideSolic = () => {
        this.setState({show: false});
    }


    showModalConfirm = (reqid, bkp, origAppr) => {
        if(bkp === 'B'){
            this.setState({isBkp: 'Y'});
            this.setState({oriApprv: origAppr});
        }
        else{
            this.setState({isBkp:''});
            this.setState({oriApprv: ''});
        }
        this.setState({selectedId: reqid});
        var myModal = new Modal(document.getElementById('ModalConfirm'));
        document.getElementById('nputComment').value = '';
        myModal.show();
       
    }


    showModalConfirmReject = (reqid,bkp, origAppr) => {
        if(bkp === 'B'){
            this.setState({isBkp:'Y'});  
            this.setState({oriApprv: origAppr});     
        }
        else{
            this.setState({isBkp:''});
            this.setState({oriApprv: ''});
        }
        this.setState({selectedId: reqid});
        var rejModal = new Modal(document.getElementById('ModalConfirmReject'));
        document.getElementById('nputCommentRej').value = '';
        rejModal.show();
    }


    rejectOne = () => {
       
        let buttonEl = document.getElementById('mdlBtnRej');

        if(buttonEl.getAttribute('clicked') === 'no'){
            buttonEl.setAttribute('clicked', 'yes'); 

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json charset=utf-8', },
                body: JSON.stringify({ 
                    userid: window.sessionStorage.getItem("userId"),
                    reqid: this.state.selectedId,
                    userComment: document.getElementById('nputCommentRej').value.trim(),
                    isBackup: this.state.isBkp,
                    origApprov: this.state.oriApprv,
                })
            };

            let modalReject = Modal.getInstance(document.getElementById('ModalConfirmReject'));
            modalReject.hide();

            let modalWntEl = document.getElementById('ModalWtng');
            let modalW = new Modal(modalWntEl);

            modalWntEl.addEventListener('shown.bs.modal',() =>{
                
                fetch(apisettigs.endpoints.rejectRequest, requestOptions).then(response => response.json())
                .then(data => {
                    buttonEl.setAttribute('clicked', 'no');
                    //console.log(data);

                    let modalHasMsg = Modal.getOrCreateInstance(document.getElementById('ModalUnreadMsg'));

                    let modalW2 = Modal.getOrCreateInstance(modalWntEl);
                    modalW2.hide();

                    if(data.ApproveResult === 'unreadMsg'){
                        modalHasMsg.show();
                    }

                    //reload the view
                    this.hideSolic();
                    this.showSolic();
                })  

            });
            
            modalW.show();
        
        }
        
    }


    approveOne = () => {

        let buttonEl = document.getElementById('mdlBtnApprv');
        
        if(buttonEl.getAttribute('clicked') === 'no'){

            buttonEl.setAttribute('clicked', 'yes');

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json charset=utf-8', },
                body: JSON.stringify({ 
                    userid: window.sessionStorage.getItem("userId"),
                    reqid: this.state.selectedId,
                    userComment: document.getElementById('nputComment').value.trim(),
                    isBackup: this.state.isBkp,
                    origApprov: this.state.oriApprv,
                })
            };
                    

            let modalApprove = Modal.getInstance(document.getElementById('ModalConfirm'));
            modalApprove.hide();
            
            let modalWntEl = document.getElementById('ModalWtng');
            let modalW = new Modal(modalWntEl);
              
            modalWntEl.addEventListener('shown.bs.modal',() =>{
                
                fetch(apisettigs.endpoints.approveRequest, requestOptions).then(response => response.json())
                .then(data => {
                    buttonEl.setAttribute('clicked', 'no');
                    //console.log(data);
                   
                    let modalHasMsg = Modal.getOrCreateInstance(document.getElementById('ModalUnreadMsg'));

                    let modalW2 = Modal.getOrCreateInstance(modalWntEl);
                    modalW2.hide();
                    
                    if(data.ApproveResult === 'unreadMsg'){
                        modalHasMsg.show();
                    }
                    
                    //reload the view
                    this.hideSolic();
                    this.showSolic();
                })  

            });
            
            modalW.show();

        }

        
    }
   
    approveAll = (event) => {
        let buttonEl = event.target;
        
        const selectedReqs = document.getElementsByClassName("requestSelect");

        let selectedRequestIds = [];

        for (var checkbox of selectedReqs){
            if (checkbox.checked){
                selectedRequestIds.push({'reqid': checkbox.getAttribute('reqid'),
                'msgcnt': checkbox.getAttribute('msgcnt'),
                'bkp': checkbox.getAttribute('bkp'),
                'origapprove': checkbox.getAttribute('origapprove'),
                });
            }
        }

        if (selectedRequestIds.length >= 1){
            buttonEl.disabled = true;
            
            let modalWntEl3 = document.getElementById('ModalWtng');            
            let modalW3 = new Modal(modalWntEl3);

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json charset=utf-8', },
                body: JSON.stringify({ 
                    userid: window.sessionStorage.getItem("userId"),
                    reqlist: selectedRequestIds,
                })
            };

            modalWntEl3.addEventListener('shown.bs.modal',() => {
                
                fetch(apisettigs.endpoints.approveAllRequest, requestOptions).then(response => response.json())
                .then(data => {
                    buttonEl.setAttribute('clicked', 'no');
                    //console.log(data);
                   
                    let modalHasMsg = Modal.getOrCreateInstance(document.getElementById('ModalUnreadMsg'));

                    let modalW23 = Modal.getOrCreateInstance(modalWntEl3);
                    modalW23.hide();
                    
                    if(data.ApproveResult === 'unreadMsg'){
                        modalHasMsg.show();
                    }

                    //reload the view
                    this.hideSolic();
                    this.showSolic();
                })  

            });
            
            modalW3.show();
            //console.log(selectedRequestIds);
        }

    }

    showMensagens = (reqType, reqid) =>{
        this.props.showMensagens(reqType, reqid, 'N');
    }

    showListarItens = (reqType, reqid) =>{
        this.props.showListarItens(reqType, reqid)
    }

    ocultarEnv(count){
        if(count <= 0){
            return 'd-none'
        }
    }

    render(){
        if (this.state.show === true){

            return (
                <>
                    {this.state.requests.map( (request) => { 
                        return ( 
                            <>
                                <div className='container mt-4'>

                                    <div className='row justify-content-center'>
                                        <div className='colTitle col- align-self-center ' style={{width:'6rem', padding:'0 0 0 0.2rem'}}> 
                                            Dt.Lançamento
                                        </div>
                                        <div className='colText col- align-self-center ' style={{ maxWidth:'59%'}}>
                                            {request.creadate}
                                        </div>
                                        <div className='colText col- ' style={{width:'1.8rem', padding:'0'}}>
                                            <img className={request.hasMsg} src={apisettigs.serverUrl + 'static/images/msgsm.png'} alt="" />
                                        </div>
                                    </div>

                                    <div className='row justify-content-center'>
                                        <div className='colTitle col-  align-self-center ' style={{width:'6rem', padding:'0 0 0 0.2rem'}}>
                                            Dt.Necessária
                                        </div>
                                        <div className='colText col- align-self-center ' style={{maxWidth:'59%'}}>
                                            {request.reqdate}
                                        </div>
                                        <div className='colText col- align-self-center ' style={{width:'1.8rem', padding:'0.5rem 0 0 0'}}>
                                            <div className={'position-relative ' + this.ocultarEnv(request.msgCnt) } >
                                                <img src={apisettigs.serverUrl + 'static/images/mail-icon-post.png'} alt="" height="auto" width="25px"/>
                                                <div className="badgeM badgeM-pad2">{request.msgCnt}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row justify-content-center'>
                                        <div className='colTitle col- align-self-center ' style={{width:'6rem', padding:'0 0 0 0.2rem'}}>
                                            Solicitante
                                        </div>
                                        <div className='colText col- align-self-center ' style={{maxWidth:'59%'}}>
                                            {request.solic}
                                        </div>
                                        <div className='colText col- ' style={{width:'1.8rem', padding:'0'}}></div>
                                    </div>

                                    <div className='row justify-content-center'>
                                        <div className='colTitle col-  align-self-center' style={{width:'6rem', padding:'0 0 0 0.2rem'}}>
                                            Dpto.Solicitante
                                        </div>
                                        <div className='colText col-  align-self-center ' style={{maxWidth:'59%', paddingBottom:'.1rem'}}>
                                            {request.ccnum} - {request.ccname}
                                        </div>
                                        <div className='colText col- align-self-center ' style={{width:'1.8rem', padding:'0'}}>
                                            <input className='form-check-input requestSelect' type="checkbox" style={{fontSize:'1.5rem'}} reqid={request.id} msgcnt={request.msgCnt} bkp={request.bkp} origapprove={request.origiApprov} />
                                        </div>
                                    </div>

                                    <div className='row justify-content-center'>
                                        <div className='colTitle col- align-self-center ' style={{width:'6rem', padding:'0 0 0 0.2rem'}}>
                                            Observação
                                        </div>
                                        <div className='colText col- align-self-center ' style={{maxWidth:'59%'}}>
                                            {request.comments}
                                        </div>
                                        <div className='colText col- align-self-center text-center' style={{width:'1.8rem', padding:'1rem 0 0 0'}}>
                                            <div style={{color:'red',fontSize:'1rem'}}>
                                                {request.bkp}
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row justify-content-center'>
                                        <div className='colTitle col-  align-self-center'  style={{width:'6rem', padding:'0 0 0 0.2rem'}}>
                                            Valor
                                        </div>
                                        <div className='colText col-  align-self-center' style={{maxWidth:'59%'}}>
                                            {request.value}
                                        </div>
                                        <div className='colText col- ' style={{width:'1.8rem', padding:'0'}}></div>
                                    </div>

                                    <div className='row justify-content-center'>
                                        <div className='colTitle col-  align-self-center'  style={{width:'6rem', padding:'0 0 0 0.2rem'}}>
                                            Ult.Aprovador
                                        </div>
                                        <div className='colText col-  align-self-center' style={{maxWidth:'59%'}}>
                                            {request.lastApprov}
                                        </div>
                                        <div className='colText col- ' style={{width:'1.8rem', padding:'0'}}></div>
                                    </div>

                                    <div className='container mt-3'>
                                        <div className='d-flex  justify-content-center' style={{width:'100%'}} > 
                                            <div className='btnGrey' onClick={()=> this.showListarItens('Solicitação', request.id)}><i className="fas fa-bars"></i></div>
                                            <div className='btnYellow' onClick={() => this.showMensagens('Solicitação', request.id)}><i className="fas fa-envelope-open-text"></i></div>
                                            <div className='btnRed' onClick={() => this.showModalConfirmReject(request.id, request.bkp, request.origiApprov)} ><i className="fas fa-times"></i></div>
                                            <div className='btnGreen' onClick={() => this.showModalConfirm(request.id, request.bkp, request.origiApprov)}><i className="fas fa-check"></i></div>
                                        </div>
                                    </div>

                                    <hr className='hLn'/>

                                </div>

                            </>); 
                        }
                    )}

                    <div className='container text-center mt-4 mb-4'>
                        <button type="button" className="btn btn-primary" onClick={this.approveAll}>Aprovar Selecionados</button>
                    </div>
                    
                    <ModalConfirm approve={this.approveOne}/>
                    <ModalConfirmReject reject={this.rejectOne}/>
                    <ModalWtng />
                    <ModalHasUnreadMsg />
                </>
       
            );  

        }
        else{
            return null;
        }
    }

}

export default Solicitacao;